import React from 'react'
import { connect } from 'react-redux'

import { requestStates } from 'core.utils/requestStates'
import {
  editUserRequested,
  selectors as usersSelectors
} from 'core.modules/users/reducer'

import Snackbar from 'core.ui/Snackbar'
import UserForm from '../UserForm'

class UserEdit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      waitingForRequest: false,
      openSnackBar: false
    }
  }

  componentDidUpdate(prevProps) {
    const { currentRequestState } = this.props
    const { waitingForRequest } = this.state
    if (
      waitingForRequest &&
      prevProps.currentRequestState === requestStates.PENDING &&
      currentRequestState === requestStates.SUCCESS
    ) {
      this.props.history.goBack()
      this.setState({ waitingForRequest: false })
    } else if (
      waitingForRequest &&
      prevProps.currentRequestState === requestStates.PENDING &&
      currentRequestState === requestStates.FAILED
    ) {
      this.setState({ waitingForRequest: false, openSnackBar: true })
    }
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackBar: false })
  }

  handleSubmit = (userInfos, userId) => {
    const { editUser } = this.props
    const { password, ...dataWithoutPassword } = userInfos
    this.setState({ waitingForRequest: true })
    if (password === '') {
      editUser(userId, dataWithoutPassword)
    } else {
      editUser(userId, userInfos)
    }
  }

  handleCancel = () => {
    this.props.history.goBack()
  }

  render() {
    const { id, data = {} } = this.props
    const { password, ...dataWithoutPassword } = data
    return (
      <React.Fragment>
        <UserForm
          id={id}
          data={dataWithoutPassword}
          onCancel={this.handleCancel}
          onSubmit={this.handleSubmit}
          isPasswordRequired={false}
          showLoading={this.state.waitingForRequest}
        />
        <Snackbar
          open={this.state.openSnackBar}
          onClose={this.handleCloseSnackbar}
          severity="error"
          message={this.props.errorMessage}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  currentRequestState: usersSelectors.getRequestState(state),
  errorMessage: usersSelectors.getErrorMessage(state)
})

const mapDispatchToProps = dispatch => ({
  editUser: (userId, userInfos) => {
    dispatch(editUserRequested(userId, userInfos))
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserEdit)
